import { render, staticRenderFns } from "./a-section.vue?vue&type=template&id=d305b7c8&scoped=true"
import script from "./a-section.vue?vue&type=script&lang=js"
export * from "./a-section.vue?vue&type=script&lang=js"
import style0 from "./a-section.vue?vue&type=style&index=0&id=d305b7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d305b7c8",
  null
  
)

export default component.exports